import api from '@/client/core/api'

export default class TwitterUpload {
  /**
   * メディアをチェック
   */
  static checkValidMedia(file: File, validFormat: string[]) {
    if (!validFormat.includes(file.type)) {
      return {
        error: 'INVALID_MEDIA'
      }
    }

    if (file.type.includes('image')) {
      return this.checkValidImage(file)
    }

    return this.checkValidVideo(file)
  }

  /**
   * 動画をチェック
   */
  static checkValidVideo(file: File) {
    const maxSize = 25 * 1024 * 1024
    if (file.size > maxSize) {
      return {
        error: 'MAX_SIZE_VIDEO'
      }
    }

    return {
      data: true
    }
  }

  /**
   * 画像の容量とサイズのチェック
   */
  static async checkValidImage(file: File) {
    const maxSize = 5 * 1024 * 1024
    if (file.size > maxSize) {
      return {
        error: 'MAX_SIZE_IMAGE'
      }
    }

    const dimensions = await this.getImageDimension(file)
    let isError = dimensions.width < 5 || dimensions.width > 5000 || dimensions.height < 5 || dimensions.height > 5000

    if (!isError && file.type.match('gif')) {
      isError = dimensions.width > 2048 || dimensions.height > 2048
    }

    if (isError) {
      return {
        error: 'INVALID_DIMENSION'
      }
    }

    return {
      data: true
    }
  }

  /**
   * 画像サイズを取得
   */
  static getImageDimension(file: File) {
    const img = new Image()
    return this.readTemporaryFileReader(file).then(result => {
      if (typeof result === 'string') img.src = result
      return new Promise<{ width: number; height: number }>(resolve => {
        img.onload = () => {
          resolve({ width: img.width, height: img.height })
        }
      })
    })
  }

  /**
   * ファイルの取得
   */
  static readTemporaryFileReader(file: File) {
    const fr = new FileReader()
    return new Promise<string | ArrayBuffer | null>(resolve => {
      fr.readAsDataURL(file)
      fr.onload = () => {
        resolve(fr.result)
      }
    })
  }

  /**
   * メディアの検証
   */
  static async checkMedia(formData: FormData) {
    const checkMedia = await api.post('/twitter_uploads/media_check', formData, {
      headers: {
        'Content-Type': undefined
      }
    })

    if (!checkMedia.data) {
      return false
    }

    return true
  }

  /**
   * メディアの検証
   */
  static async validateFile(file: File) {
    const formData = new FormData()
    formData.append('files', file)

    const data = await api.post('/twitter_medias/validations', formData)

    if (!data || !data.data || !data.data.filename) {
      return { error: 'UPLOAD_FAILED' }
    }

    const delay = (miliseconds: number) => {
      return new Promise(resolve => {
        setTimeout(() => {
          resolve(true)
        }, miliseconds)
      })
    }

    const LOOP = true

    while (LOOP) {
      const result = await api.get(`/twitter_medias/validations_progresses?filename=${data.data.filename}`)

      if (result && result.data && result.data.mediaUrl) {
        return { data: result.data.mediaUrl }
      }

      if (result && result.error) {
        return { error: 'VALIDATION_FAILED' }
      }

      if (!result || !result.data) {
        return { error: 'CHECK_PROGRESSES_FAILED' }
      }

      await delay(3000)
    }
  }

  /**
   * メディアのアップロード
   */
  static uploadMedia(formData) {
    return api.post('/twitter_uploads', formData, {
      headers: {
        'Content-Type': undefined
      }
    })
  }

  /**
   * メディアのアップロード
   */
  static uploadMediaFromUrl(params: any) {
    return api.post('/twitter_uploads', params)
  }
}
